import { saveChangeSignatoryAction, getChangeSignatoryAction } from "./action";

const initialState = {
  saveChangeSignatory: "",
  getChangeSignatory: "",
  error: "",
};

const saveChangeSignatoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveChangeSignatoryAction.SAVE_CHANGE_SIGNATORY_DETAILS_SUCCESS:
      return {
        ...state,
        saveChangeSignatory: action.payload,
      };
    case saveChangeSignatoryAction.SAVE_CHANGE_SIGNATORY_DETAILS_ERROR:
      return {
        ...state,
        saveChangeSignatory: "",
        error: "",
      };

    case getChangeSignatoryAction.GET_CHANGE_SIGNATORY_DETAILS_SUCCESS:
      return {
        ...state,
        getChangeSignatory: action.payload,
      };
    case getChangeSignatoryAction.GET_CHANGE_SIGNATORY_DETAILS_ERROR:
      return {
        ...state,
        getChangeSignatory: "",
        error: "",
      };

    default:
      return state;
  }
};

export default saveChangeSignatoryReducer;
